import { ProjectionsList, ShapeProperty, LabelProperty, TemplateProperty, ApiEntity, CrudEntity, IdKeyType, SizeEntity, } from "./types/index.js";
import { EnumReader } from "./utils/helpers.js";
export const ProjectionsReader = new EnumReader(ProjectionsList);
export const ApiEntityReader = new EnumReader(ApiEntity);
export const IdKeyTypeReader = new EnumReader(IdKeyType);
export const SizeReader = new EnumReader(SizeEntity);
export const CrudEntityReader = new EnumReader(CrudEntity);
export const TemplateOptionsReader = new EnumReader({
    ...TemplateProperty,
    ...ShapeProperty,
    ...LabelProperty,
});
